import { render, staticRenderFns } from "./waterfall_3.vue?vue&type=template&id=b49f1692&scoped=true&"
import script from "./waterfall_3.vue?vue&type=script&lang=js&"
export * from "./waterfall_3.vue?vue&type=script&lang=js&"
import style0 from "./waterfall_3.vue?vue&type=style&index=0&id=b49f1692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f1692",
  null
  
)

export default component.exports